'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from 'react';
import styled from 'styled-components';
import enviro from 'enviro';
import UsageTracker from '../../utils/UsageTracker';
import { SCREENS } from '../../constants/Tracking';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import EmbeddedSignup from '../EmbeddedSignup';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import Small from 'UIComponents/elements/Small';
const SignupContainer = styled(UIFlex).withConfig({
  displayName: "HublessError__SignupContainer",
  componentId: "sc-1t0pdca-0"
})(["position:relative;"]);
const SignupFrame = styled(UIBox).withConfig({
  displayName: "HublessError__SignupFrame",
  componentId: "sc-1t0pdca-1"
})(["width:100%;"]);
const Annotation = styled.div.withConfig({
  displayName: "HublessError__Annotation",
  componentId: "sc-1t0pdca-2"
})(["position:absolute;bottom:40px;max-width:400px;text-align:center;"]);
export default class HublessError extends PureComponent {
  componentDidMount() {
    const {
      email
    } = this.props;
    UsageTracker.setUpHublessTracker(email).trackHubless('pageView', {
      screen: SCREENS.HUBLESS
    });
  }

  render() {
    const env = enviro.getShort();
    return /*#__PURE__*/_jsxs(SignupContainer, {
      align: "center",
      direction: "column",
      justify: "center",
      children: [/*#__PURE__*/_jsx(SignupFrame, {
        grow: 2,
        children: /*#__PURE__*/_jsx(EmbeddedSignup, {
          env: env
        })
      }), /*#__PURE__*/_jsx(Annotation, {
        children: /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `learningCenter.errors.hubless.certsLocation`
          })
        })
      })]
    });
  }

}